// extracted by mini-css-extract-plugin
var _1 = "ikh_SA9w7ESU5ICpnKAY";
export { _1 as "shared" }
